import { takeEvery } from 'redux-saga/effects';

import * as homeActions from 'store/modules/home';
import { loadReviews } from './utils';

export default function* listenLoadReviews() {
  yield takeEvery(homeActions.loadReviews.toString(), loadReviews);
}
